(function(){
  var slides    = document.querySelectorAll('.jcs-tl-slide');
  var prev      = document.getElementById('jcsTlPrev');
  var next      = document.getElementById('jcsTlNext');
  var mapPoints = document.querySelectorAll('.jcs-tl-map__point');
  var mapProg   = document.getElementById('jcsTlMapProgress');
  var current   = 0;
  var total     = slides.length;

  function isMobile() { return window.innerWidth <= 860; }

  function updateMap(i) {
    mapPoints.forEach(function(p, idx) {
      p.classList.remove('is-active', 'is-passed');
      if (idx === i) p.classList.add('is-active');
      else if (idx < i) p.classList.add('is-passed');
    });
    var pct = total > 1 ? (i / (total - 1)) * 100 : 0;
    if (isMobile()) {
      mapProg.style.width = '';
      mapProg.style.height = pct + '%';
    } else {
      mapProg.style.height = '';
      mapProg.style.width = pct + '%';
    }
  }

  function goTo(i) {
    if (i < 0 || i >= total) return;
    if (!isMobile()) {
      slides[current].classList.remove('is-active');
    }
    current = i;
    if (!isMobile()) {
      slides[current].classList.add('is-active');
      prev.disabled = current === 0;
      next.disabled = current === total - 1;
    }
    updateMap(current);
  }

  prev.addEventListener('click', function(){ goTo(current - 1); });
  next.addEventListener('click', function(){ goTo(current + 1); });

  mapPoints.forEach(function(p){
    p.addEventListener('click', function(){
      var idx = parseInt(p.dataset.map);
      if (isMobile()) {
        slides[idx].scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      goTo(idx);
    });
  });

  /* Keyboard navigation */
  document.addEventListener('keydown', function(e){
    if (e.key === 'ArrowLeft') goTo(current - 1);
    if (e.key === 'ArrowRight') goTo(current + 1);
  });

  /* Touch swipe (desktop slider only) */
  var track = document.getElementById('jcsTlTrack');
  var startX = 0;
  track.addEventListener('touchstart', function(e){ if(!isMobile()) startX = e.touches[0].clientX; }, {passive:true});
  track.addEventListener('touchend', function(e){
    if (isMobile()) return;
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) { diff > 0 ? goTo(current+1) : goTo(current-1); }
  }, {passive:true});

  /* Mobile: highlight card nearest to screen center on scroll + touch/hover */
  function highlightNearest() {
    if (!isMobile()) return;
    var center = window.innerHeight / 2;
    var best = -1, bestDist = Infinity;
    slides.forEach(function(s, i) {
      var r = s.getBoundingClientRect();
      var mid = r.top + r.height / 2;
      var d = Math.abs(mid - center);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    if (best >= 0 && best !== current) {
      slides.forEach(function(s){ s.classList.remove('is-active'); });
      slides[best].classList.add('is-active');
      current = best;
      updateMap(best);
    }
  }
  window.addEventListener('scroll', highlightNearest, { passive: true });
  highlightNearest();

  /* Pointer/touch: highlight whichever card the finger/cursor is over */
  slides.forEach(function(s, i) {
    function activate() {
      slides.forEach(function(sl){ sl.classList.remove('is-active'); });
      s.classList.add('is-active');
      current = i;
      updateMap(i);
    }
    s.addEventListener('pointerenter', activate);
    s.addEventListener('touchstart', activate, { passive: true });
  });

  updateMap(0);

  /* ── Craft steps: Apple-style scroll reveal on mobile ── */
  (function initCraftReveal() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: show all steps immediately
      document.querySelectorAll('.jcs-craft-tl__step').forEach(function(s) {
        s.classList.add('is-visible');
      });
      return;
    }

    var craftSteps = document.querySelectorAll('.jcs-craft-tl__step');
    if (!craftSteps.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -10% 0px'
    });

    craftSteps.forEach(function(step) {
      observer.observe(step);
    });
  })();

  /* Mobile: hide map when scrolled past the history section */
  var tlSection = document.querySelector('.jcs-tl-section');
  var mapEl = document.getElementById('jcsTlMap');
  if (tlSection && mapEl) {
    function checkMapVisibility() {
      if (!isMobile()) { mapEl.style.opacity = ''; mapEl.style.pointerEvents = ''; return; }
      var rect = tlSection.getBoundingClientRect();
      var sectionBottom = rect.bottom;
      var sectionTop = rect.top;
      var buffer = 80;
      if (sectionBottom < buffer || sectionTop > window.innerHeight - buffer) {
        mapEl.style.opacity = '0';
        mapEl.style.pointerEvents = 'none';
      } else {
        mapEl.style.opacity = '1';
        mapEl.style.pointerEvents = '';
      }
    }
    window.addEventListener('scroll', checkMapVisibility, { passive: true });
    window.addEventListener('resize', checkMapVisibility);
    checkMapVisibility();
  }
})();